import React from "react";
import { useNavigate } from "react-router-dom";

function Privacy() {
    const navigate = useNavigate();

    return (
        <div className="privacy-container" style={{
            fontFamily: 'Arial, sans-serif',
            lineHeight: 1.6,
            color: '#333',
            maxWidth: '800px',
            margin: '0 auto',
            padding: '20px'
        }}>
            <h2 style={{
                color: '#004d26',
                borderBottom: '2px solid #004d26',
                paddingBottom: '10px'
            }}>Data Overview for LOCI Safety Training SCORM Package</h2>

            <p>
                The SCORM file generated by LOCI's web-based Quest creator for the safety
                training scavenger hunt contains the following:
            </p>

            <h3 style={{ color: '#004d26', marginTop: '25px' }}>1. Data Used by LOCI:</h3>
            <ul style={{ paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>
                    <strong>Email of the Quest Creator:</strong> This is required to create
                    and manage the Quest.
                </li>
                <li style={{ marginBottom: '8px' }}>
                    <strong>Installation Location Addresses:</strong> The addresses where
                    the QR code sticker Quest is placed for the training Quests.
                </li>
                <li style={{ marginBottom: '8px' }}>
                    <strong>GPS Location:</strong> Logged when the stickers are placed to
                    ensure accurate tracking of where physical training elements (QR codes)
                    are installed.
                </li>
            </ul>

            <h3 style={{ color: '#004d26', marginTop: '25px' }}>2. SCORM File Content:</h3>
            <ul style={{ paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>
                    The SCORM package contains a PDF file for testing QR code scans and an
                    image of the QR code that is used in the scavenger hunt.
                </li>
                <li style={{ marginBottom: '8px' }}>
                    The SCORM file itself is published and hosted entirely within the
                    organization's Learning Management System (LMS). LOCI does not host,
                    access, or see any of the SCORM files created by your organization.
                </li>
            </ul>

            <div style={{
                backgroundColor: '#f8f9fa',
                padding: '15px',
                borderLeft: '4px solid #004d26',
                margin: '15px 0'
            }}>
                <h3 style={{ color: '#004d26' }}>3. Security and Data Privacy:</h3>
                <ul style={{ paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '8px' }}>
                        No sensitive data (such as floor plans, employee names, personal
                        information, or training records) is shared with LOCI. The data
                        tracked within the LMS remains fully under the control of your
                        organization.
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                        The SCORM file is created, stored and managed on-premise within your
                        company's LMS, and LOCI has no visibility into the SCORM files once
                        they are published.
                    </li>
                </ul>
            </div>

            <p>
                This structure ensures that LOCI only handles minimal data related to
                Quest setup and physical locations, while all employee training records
                and Quest completion data are managed by your own systems.
            </p>

            <div style={{ marginTop: '30px', fontStyle: 'italic' }}>
                <p>
                    <a href="http://www.learnbyloci.com" target="_blank" rel="noopener noreferrer"
                        style={{ color: '#004d26', textDecoration: 'none' }}>
                        www.learnbyloci.com
                    </a>
                    &nbsp;|&nbsp;
                    <a href="mailto:info@learnbyloci.com" style={{ color: '#004d26', textDecoration: 'none' }}>
                        info@learnbyloci.com
                    </a>
                </p>
            </div>
        </div>
    );
}

export default Privacy;